import { adminRouterMap, adminAbroadRouterMap, customerAbroadRouterMap, baseRouterMap, abroadRouterMap, customerRouterMap, constantRouterMap, bindAccountRouterMap } from '@/router'


/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(role => route.meta.role.indexOf(role) >= 0)
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: [], // menu
    addRouters: [], // push routes
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      // 判断是否海外
      let areaType = localStorage.getItem('areaType')
      // this.$router.go(0)
      if (areaType == 0) {
        state.addRouters = routers
        state.routers = constantRouterMap.concat(routers)
      } else {
        state.addRouters = routers
        state.routers = abroadRouterMap.concat(routers)
      }
    }
  },
  actions: {
    GenerateRoutes({ commit }, userInfo) {
      return new Promise(resolve => {
        const { accountType, proxyAccount } = userInfo
        let accessedRouters = []
        let areaType = localStorage.getItem('areaType')
        if (!proxyAccount) {
          accessedRouters = baseRouterMap
          if (areaType == 1) {
            if (accountType == 1) {
              accessedRouters = [...accessedRouters, ...adminAbroadRouterMap]
            } else {
              accessedRouters = [...accessedRouters, ...customerAbroadRouterMap]
            }
          }else{
            if (accountType == 1) {
              accessedRouters = [...accessedRouters, ...adminRouterMap]
            } else {
              accessedRouters = [...accessedRouters, ...customerRouterMap]
            }
          }
        } else {
          accessedRouters = bindAccountRouterMap
        }
        // accessedRouters = [...accessedRouters, ...bindAccountRouterMap]
        // console.log("adminRouterMap**********", accessedRouters);
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js